import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
function Image(props) {
    const { src, alt, loading = 'lazy', width, height, className, ...ImageProps } = props;
    return (_jsx("picture", { className: clsx('Image', className), children: _jsx("img", { loading: loading, src: src, alt: alt, width: width, height: height, ...ImageProps }) }));
}
export default Image;
